module.exports = __webpack_public_path__ + "static/3-35eea0ded30dcddf84f87b7784e44378.png";